<h2 mat-dialog-title appLocalizationPopupDirective localizationCode="ImportColumnMapping">
    {{ 'ImportColumnMapping' | translate: {Default: "Column Mapping"} }}
</h2>

<mat-dialog-content>
    <form [formGroup]="columnMapping">
        <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportSheetColumn">
            <mat-label>{{ 'ImportSheetColumn' | translate: {Default: "Sheet Column"} }}</mat-label>
            <input matInput formControlName="sheetColumn">
        </mat-form-field>

        <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportTableField">
            <mat-label>
                {{ 'ImportTableField' | translate: {Default: "Table Field"} }}
            </mat-label>

            <mat-select disableOptionCentering formControlName="tableField" class="mat-form-field">
                
                <mat-option></mat-option>

                <mat-option *ngFor="let field of fields" [value]="field.id">
                    {{field.name}}
                </mat-option>

            </mat-select>
        </mat-form-field>

        <div *ngIf="isAlookupField(columnMapping.get('tableField')?.value)" appLocalizationPopupDirective localizationCode="ImportCreateLookupIfMissing">
            <mat-slide-toggle setColor="primaryColour" formControlName="createLookupIfMissing">
                {{ 'ImportCreateLookupIfMissing' | translate: {Default: "Create Lookup If Missing"} }}
            </mat-slide-toggle>
        </div>

        <ng-container *ngIf="showImportMappingTypeField">
            <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportMappingType">
                <mat-label>
                    {{ 'ImportMappingType' | translate: {Default: "Mapping Type"} }}
                </mat-label>

                <mat-select disableOptionCentering formControlName="type">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let option of columnMappingTypes" [value]="option.id">{{ option.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">
        {{ 'Close' | translate: {Default: "Close"} }}
    </button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()">
        {{ 'Save' | translate: {Default: "Save"} }}
    </button>
</mat-dialog-actions>